// React
import React from 'react';
import ReactDOM from 'react-dom';

// Router
import AppRouter from '@barton/tbo-crm/js/Component/Router';

// Attach our div to the DOM.
window.jQuery('body').append('<div id="tbo__app--crm"></div>');

// RenderDOM
ReactDOM.render(
    <AppRouter />,
    document.getElementById('tbo__app--crm')
)


// WEBPACK FOOTER //
// ./build/tbo-crm/js/tbo-crm.js